import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {Carrier} from '../../../user-dashboard/shared/carrier.model';
import {BluechatFindCarrierByDeliveryNumber} from "../../models/BluechatFindCarrierByDeliveryNumber";

@Component({
  selector: 'app-bluechat-simple-carrier-delivery-list',
  templateUrl: './bluechat-simple-carrier-delivery-list.component.html',
  styleUrls: ['./bluechat-simple-carrier-delivery-list.component.scss']
})
export class BluechatSimpleCarrierDeliveryListComponent implements OnChanges {

  @Input()
  bluechatFindByDeliveryNumberLoad: BluechatFindCarrierByDeliveryNumber[];

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
  }

  private getDeliveriesByCarrier(carrierByDelivery: Map<string, Carrier>) {
    const res: Map<string, string[]> = this.getAllCarriers(carrierByDelivery);

    Array.from(carrierByDelivery).map(([key, value]) => {
      res.set(value.name, res.get(value.name).concat(key));
    });

    return undefined;
  }

  private getAllCarriers(carrierByDelivery: Map<string, Carrier>): Map<string, string[]> {
    let allCarriers: Carrier[] = Array.from(carrierByDelivery).map(([key, value]) => value);
    allCarriers = this.distinct(allCarriers);
    const res = new Map<string, string[]>();
    allCarriers.forEach(carrier => res.set(carrier.name, []));
    return res;
  }

  private distinct(allCarriers: Carrier[]) {
    return allCarriers.filter( (el, index) => allCarriers.indexOf(el) === index);
  }
}
